import React from "react"
import { Label, Row, Col } from "reactstrap"

import Input from '@core/components/form/input'

const DateRangeField = (props) => {
  const { formRef } = props

  return (
    <Row className="m-0 p-0">
      <Col xs={12} lg={6} className="m-0 p-0">
        <Label className="m-0 p-0" for="startDate">Start date <span>*</span></Label>
        <Row className="pl-1">
          {
            props.simple
            ?
            <React.Fragment>
              <Col xs={12} className="m-0 p-0 pr-1">
                <Input.Dropdown formRef={formRef} name="startYear" options="year" required />
              </Col>
            </React.Fragment>
            :
            <React.Fragment>
              <Col xs={6} className="m-0 p-0 pr-1">
                <Input.Dropdown formRef={formRef} name="startMonth" options="month" required />
              </Col>
              <Col xs={6} className="m-0 p-0 pr-1">
                <Input.Dropdown formRef={formRef} name="startYear" options="year" required />
              </Col>
            </React.Fragment>
          }
        </Row>
      </Col>
      {!props.ongoing &&
      <Col xs={12} lg={6} className="m-0 p-0 pl-lg-1">
        <Label className="m-0 p-0" for="startDate">End date <span>*</span></Label>
        <Row className="pr-1">
          {
            props.simple
            ?
            <React.Fragment>
              <Col xs={12} className="m-0 p-0 pl-1">
                <Input.Dropdown formRef={formRef} name="endYear" options="year" required />
              </Col>
            </React.Fragment>
            :
            <React.Fragment>
              <Col xs={6} className="m-0 p-0 pl-1">
                <Input.Dropdown formRef={formRef} name="endMonth" options="month" required />
              </Col>
              <Col xs={6} className="m-0 p-0 pl-1">
                <Input.Dropdown formRef={formRef} name="endYear" options="year" required />
              </Col>
            </React.Fragment>
          }
        </Row>
      </Col>
      }
    </Row>
  )
}

export default DateRangeField
